import { Typography } from '@mui/material'
import {
  getPanelHistory,
  useHistoryCustomBack,
  useNavigate,
  usePanelHistoryTop,
} from 'weblite-router'
import { VisibilityHandler } from '$scenes/components/visibility-handler'
import { HomePanel } from '$scenes/router-panels/router-panels'
import { NAVIGATION_BAR_HEIGHT } from '$common/navigation-bar'
import { StaticWappPanel } from '$comp/static-wapp-panel'
import { StaticPanelWappId } from '$logic/wapp-panels'
import { PageWithAppBar } from '$common/page-with-app-bar'
import { AppBarBackTitle } from '$common/app-bar/app-bar-back-title'
import { t } from '$i18n'
import { switchToRoomList } from '$logic/router'
import { usePreventPreLoad } from '$hooks/use-prevent-preload'

export function Jaryan() {
  const navigate = useNavigate()

  const homePanelState = usePanelHistoryTop('home')?.state
  const isTop = homePanelState?.tab === 'jaryan'

  const preventPreLoad = usePreventPreLoad(isTop)

  useHistoryCustomBack(
    () => {
      const panelHistory = getPanelHistory('jaryan')
      if (panelHistory.length > 1) navigate(-1)
      else
        HomePanel.navigate('home', {
          replace: true,
          absolute: true,
          data: { tab: 'roomList' },
        })
    },
    [],
    isTop,
  )

  if (preventPreLoad) return null
  return (
    <VisibilityHandler zIndex={1} considerIOSNotch>
      <PageWithAppBar
        appBar={
          <AppBarBackTitle
            title={
              <Typography variant="subtitle1" color="neutral800">
                {t('navigationBar.stream')}
              </Typography>
            }
            onBack={switchToRoomList}
          />
        }
      >
        <StaticWappPanel wappId={StaticPanelWappId.JARYAN} />
      </PageWithAppBar>
      {/*<Box sx={{ height: `calc(100% - ${NAVIGATION_BAR_HEIGHT}px)` }}>*/}
      {/*  <StaticWappPanel wappId={StaticPanelWappId.JARYAN} />*/}
      {/*</Box>*/}
    </VisibilityHandler>
  )
}
